import React from 'react';
import { Table, Button, Progress, DropdownItem, DropdownToggle, DropdownMenu, ButtonDropdown, Popover } from 'reactstrap';
import Row from '../Row';
import DropZoneTable from './DropZoneTable';
import AddDocumentFormModal from '../modals/AddDocumentFormModal';
import $ from 'jquery';
import { connect } from 'react-redux'
import ViewDocumentModal from '../modals/ViewDocumentModal';
import { Airship, Flag } from 'flagger/react';
import UpArrow from '@mui/icons-material/KeyboardArrowUp';
import DownArrow from '@mui/icons-material/KeyboardArrowDown';

class FileTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            error: false,
            pageNumber: 1,
            prevPageLimit: 0,
            rowsShown: 150,
            numPages: 1,
            currentPage: 0,
            activeIndex: 0,
            fileCount: 0,
            filesSelected: [],
            fileTypes: [],
            cSelected: [],
            addmodal: false,
            viewmodal: false,
            pageSizePopoverOpen: false,
            selectedFile: {},
            jumpToPopoverOpen: false,
            textPageNumber: 0,
            sortConfig: { key: null, direction: 'asc' },
            ...props,
            filters: {
                DocumentRef: '',
                DocumentType: '',
                Description: '',
                Folder:'',
                Version: '',
                UserName:'',
                DateTimeCreated: ''                
            },
            showFilters: false,
            selectedIds: new Set()
        }

        this.goToNextPage = this.goToNextPage.bind(this);
        this.goToPrevPage = this.goToPrevPage.bind(this);
        this.setNumberOfPages = this.setNumberOfPages.bind(this);
        this.toggleAddModal = this.toggleAddModal.bind(this);
        this.addDocument = this.addDocument.bind(this);
        this.documentSelected = this.documentSelected.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.files.length !== prevProps.files.length) {
            let noPages = Math.ceil(this.props.files.length / this.state.rowsShown)
            this.setState({
                numPages: noPages,
                currentPage: 0,
                files: this.props.files
            })
        }

        if (this.state.currentPage !== prevState.currentPage || this.state.numPages !== prevState.numPages) {
            this.setState({
                textPageNumber: this.state.currentPage + 1
            })
        }

        if (this.state.textPageNumber !== prevState.textPageNumber) {
            this.setState({
                currentPage: this.state.textPageNumber - 1
            })
        }

        if (prevState.rowsShown !== this.state.rowsShown) {
            const noPages = Math.ceil(this.props.files.length / this.state.rowsShown);
            this.setState({ numPages: noPages, currentPage: 0 });
        }
    }

    toggleRowSelection = (id) => {
        this.setState(prev => {
            const selectedIds = new Set(prev.selectedIds);
            if (selectedIds.has(id)) selectedIds.delete(id);
            else selectedIds.add(id);
            return { selectedIds };
        });
    };

    getVisibleIds = (allRows) => {
            const startIdx = this.state.currentPage * this.state.rowsShown;
            const endIdx   = startIdx + this.state.rowsShown; // exclusive
            return allRows
                .map((file, i) => ({ file, i }))
                .filter(({ i }) => this.props.nopages ? true : (i >= startIdx && i < endIdx))
                .map(({ file }) => file?._id)
                .filter(Boolean);
    };

    toggleSelectAllVisible = (visibleIds) => {
        this.setState(prev => {
            const selectedIds = new Set(prev.selectedIds);
            const allVisibleSelected = visibleIds.every(id => selectedIds.has(id));
            if (allVisibleSelected) {
            // deselect all visible
            visibleIds.forEach(id => selectedIds.delete(id));
            } else {
            // select all visible
            visibleIds.forEach(id => selectedIds.add(id));
            }
            return { selectedIds };
        });
    };

    downloadSelected = () => {
        const ids = Array.from(this.state.selectedIds || []);
        if (!ids.length) return;
        if (typeof this.props.onDownloadSelected === 'function') {
            this.props.onDownloadSelected(ids);
        }
    };

    addDocument() {
        //don't toggle yet - if the toggle goes we lose the input
        //TODO: could move the input somewhere else.
        $("#addfileId").unbind("change").bind("change", this.documentSelected);

        $("#addfileId").val("");
        //add the change event
        //$("#addfileId").change(this.documentSelected);
        //fire the click event
        $("#addfileId").trigger("click");
    }

    documentSelected() {
        //validate that we have selected a document
        if ($("#addfileId")) {
            if ($("#addfileId")[0]) {
                if ($("#addfileId")[0].files) {
                    if ($("#addfileId")[0].files[0]) {
                        //store the selected file
                        this.setState({
                            selectedDocument: $("#addfileId")[0].files[0],
                            selectedFileName: $("#addfileId")[0].files[0].name
                        });
                        //display the add new document modal.
                        this.toggleAddModal();
                    }
                }
            }
        }
    }

    clearAllSelections = () => {
        this.setState({ selectedIds: new Set() });
    };

    toggleAddModal() {
        this.setState({ addmodal: !this.state.addmodal });
    }

    toggleViewModal = (id, file) => {
        if (file)
            this.setState({
                viewmodal: true,
                selectedFile: file
            })
        else
            this.setState({
                viewmodal: !this.state.viewmodal
            })
    }

    goToNextPage() {
        let page = this.state.currentPage + 1
        if (page < this.state.numPages)
            this.setState({
                currentPage: page
            })
    }

    goToPrevPage() {
        let page = this.state.currentPage - 1
        if (page >= 0)
            this.setState({
                currentPage: page
            })
    }

    goToPageNumber = (i) => {
        this.setState({
            currentPage: i,
            jumpToPopoverOpen: false
        })
    }

    jumpToPageNumber = (value) => {
        let number = parseInt(value);
        if (number <= this.state.numPages && number > 0) {
            this.setState({
                textPageNumber: number,
                jumpToPopoverOpen: false
            })
        }
    }

    setNumberOfPages(num) {
        this.setState({
            numPages: num
        })
    }

    adjustPageSize = (size) => {
        this.setState({
            rowsShown: parseInt(size),  // Ensure numeric value
            pageSizePopoverOpen: false
        }, () => {
            const noPages = Math.ceil(this.props.files.length / this.state.rowsShown);
            this.setState({ numPages: noPages, currentPage: 0 });
        });
    };

    handleFilterChange = (key, value) => {
    this.setState((prevState) => ({
        filters: {
            ...prevState.filters,
            [key]: value
        },
        currentPage: 0 // optional: reset to first page on filter
        }));
    };

    toggleFilters = () => {
        this.setState((prevState) => ({
            showFilters: !prevState.showFilters
        }));
    };
    
    clearAllFilters = () => {
        this.setState({
            filters: {
                DocumentRef: '',
                DocumentType: '',
                Description: '',
                Folder:'',
                Version: '',
                UserName:'',
                DateTimeCreated: ''
            },
            currentPage: 0 // optional: reset to first page
        });
    };

    getTableFlaggerFields = (file) => {
        let fields = [];
        for (let i = 1; i < 12; i++) {
            let flag = Airship.flag("TableHeaderFields").getTreatment({ id: i });
            if (flag == 'on') {
                switch (i) {
                    case 1:
                        fields.push(file.DocumentRef);
                        break;
                    case 2:
                        fields.push(file.SecondRef);
                        break;
                    case 3:
                        fields.push(file.TransactionNumber);
                        break;
                    case 4:
                        fields.push(file.DocumentTypeDescription);
                        break;
                    case 5:
                        fields.push(file.Folder);
                        break;
                    case 6:
                        fields.push(file.Version);
                        break;
                    case 7:
                        fields.push(file.Value);
                        break;
                    case 8:
                        var archiveUsername = file.ArchiveUser ? file.ArchiveUser : file.UserName;
                        fields.push(archiveUsername);
                        break;
                    case 9:
                        fields.push(file.Pages);
                        break;
                    case 10:
                        fields.push(file.DateTimeCreated);
                        break;
                    case 11:
                        if(typeof (file.Description) === 'undefined' || file.Description === null || file.Description === '')
                        { 
                            fields.push(" ");
                        }
                        else{
                            fields.push(file.Description);
                        }
                }
            }
        }
        return fields;
    }

    onSort = (key) => {
        this.setState((prevState) => {
            const direction = prevState.sortConfig.key === key && prevState.sortConfig.direction === 'asc' ? 'desc' : 'asc';

            const files = prevState.files ?? this.props.files;

            const sortedRows = [...files].sort((a, b) => {
                let aValue = a[key];
                let bValue = b[key];

                // Fallback in case of undefined values
                if (aValue == null) aValue = '';
                if (bValue == null) bValue = '';

                if (typeof aValue === 'string') aValue = aValue.toLowerCase();
                if (typeof bValue === 'string') bValue = bValue.toLowerCase();

                if (aValue < bValue) return direction === 'asc' ? -1 : 1;
                if (aValue > bValue) return direction === 'asc' ? 1 : -1;
                return 0;
            });

            return {
                files: sortedRows,
                sortConfig: { key, direction }
            };
        });
    };

    renderSortableFilterableHeader = (filterKey, label, flag = null, entity = null, flagCase = 'on', showFilterInput = true) => {
        const isSorted = this.state.sortConfig.key === filterKey;
        const sortArrow = isSorted
            ? this.state.sortConfig.direction === 'asc'
            ? <UpArrow />
            : <DownArrow />
            : null;

        const header = (
            <th
            key={filterKey}
            className="s-grid-title-cell"
            style={{ cursor: 'pointer' }}
            onClick={() => this.onSort(filterKey)}
            >
            <div className="s-grid-title-cell-label">
                {label} {sortArrow}
            </div>
            {showFilterInput && this.state.showFilters && (
                <div>
                <input
                    className="form-control form-control-sm"
                    type="text"
                    placeholder="Start typing to search..."
                    value={this.state.filters[filterKey] || ''}
                    onMouseDown={(e) => e.stopPropagation()}
                    onChange={(e) => this.handleFilterChange(filterKey, e.target.value)}
                />
                </div>
            )}
            </th>
        );

        if (flag) {
            return (
            <Flag flag={flag} entity={entity} case={flagCase}>
                {header}
            </Flag>
            );
        }

        return header;
    };


    getLocalizedLabel = (key, fallback) => {
      const labelObj = this.props.userReducer.localisation[key];
      return labelObj?.element_lang || fallback;
    };


    render() {
        

        var style = {};
        style.display = 'none';
        const { currentPage, rowsShown, prevPageLimit, numPages } = this.state;

        //var rows = []
        var b = true
        let grid_css
        let id
        let add_button = []
        let refresh_button = {}
        let pagination = {}
        let drop_zone = {}
        let is_checked = {}
        let rows = []

        const { localisation } = this.props.userReducer;

        const filtersActive = Object.values(this.state.filters).some(
            val => val.trim() !== ''
        );

        const startItem = this.state.currentPage * this.state.rowsShown;
        const endItem   = startItem + this.state.rowsShown;

        let pageSizes = [10, 50, 100, 200, 500];
        let pageSizeItems = [];

        let logsToRender = (this.state.files?.length ? this.state.files : this.props.files).filter(file => {
            const { filters } = this.state;

            const matches = (field, value) => {
              if (!value.trim()) return true; // if no filter applied, always match
              return (field ?? '').toString().toLowerCase().includes(value.toLowerCase());
            };

            const extractDatePortion = (dateStr) => {
                if (!dateStr) return '';
                const date = new Date(dateStr);

                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = String(date.getFullYear()).slice(2);

                return `${day}/${month}/${year}`;
            };


            const userInput = filters.DateTimeCreated.trim();
            const matchDate = userInput
                ? extractDatePortion(file.DateTimeCreated).includes(userInput)
                : true;

            return (
                matches(file.DocumentRef, filters.DocumentRef) &&
                matches(file.DocumentType, filters.DocumentType) &&
                matches(file.Description, filters.Description) && 
                matches(file.Folder, filters.Folder) &&
                matches(file.Version, filters.Version) &&
                matches(file.UserName, filters.UserName) &&
                matchDate
            );
        });

        const allRows = logsToRender; // already filtered list you render
        const visibleIds = this.getVisibleIds(allRows);
        const showSelectVisible = !!this.props.columnConfig?.checkbox && visibleIds.length > 0;
        const allVisibleSelected = visibleIds.length > 0 && visibleIds.every(id => this.state.selectedIds.has(id));
        const selectedCount = this.state.selectedIds.size;

        if (this.props.add) {
            add_button.push(
                <div class="s-array-topbar-left">
                    <label class="s-pager s-pager-range">
                        <a onClick={this.addDocument} class="s-pager-link s-fonticon-btn s-btn-plus"></a>
                    </label>
                </div>
            )
        }
        else
            add_button.push(<div />)


        if (logsToRender) {
            logsToRender.forEach((file, i) => {
                if (!this.props.nopages) {
                    if (i < startItem)
                        return
                    if (i >= endItem)
                        return
                }

                 var isParentRow = false;
            var isChildRow = false;
            var isDummyRow = false;
            if (!this.props.nopages) {
                if (i < startItem)
                    return
                if (i >= endItem)
                    return
            }

            if (b)
                grid_css = "s-grid-row"
            else
                grid_css = "s-grid-row s-record-alt"
            b = !b

            if (this.props.keyid !== undefined && this.props.keyid > i) {
                isParentRow = true;
                isChildRow = false;
            }
            else if (this.props.keyid !== undefined && this.props.keyid == i) {
                isParentRow = true;
                isChildRow = false;
            }
            else {
                isChildRow = true;
            }

            if (file.Status === 'Dummy' || file.Version === "0") {
                grid_css += " dummy-row"
                isDummyRow = true;
            }

            id = "P" + file._id

            if (this.props.checkedFiles && this.props.checkedFiles.includes(file))
                is_checked = true
            else
                is_checked = false

            let fields = this.getTableFlaggerFields(file);

            if (this.props.associated_children && this.props.associated_children.length > 0) {
                var found = this.props.associated_children.find(element => {
                    return element.id == file._id || element.id == file.parentId;
                });

                rows.push(<Row
                    expandLogs={this.props.expandLogs}
                    parentRow={isParentRow}
                    childRow={isChildRow}
                    expandOpen={found ? (found.associated.length > 0 ? true : false) : false}
                    viewPortfolio={this.props.viewPortfolio}
                    onRowClicked={this.props.checkChange}
                    rightAlign={[5]}
                    is_checked={this.state.selectedIds.has(file._id)}
                    checked={this.props.checked}
                    i={i}
                    checkChange={(id) => this.toggleRowSelection(id)}
                    refresh={this.props.refresh}
                    id={id}
                    fileid={file._id}
                    tr_css={grid_css}
                    filename={fields[0]}
                    filetypedesc={fields[1]}
                    filetype={file.DocumentType}
                    description={fields[5]}
                    version={fields[2]}
                    user={fields[3]}
                    file={file}
                    pages={file.Pages}
                    dated={fields[4]}
                    fileTable={true}
                    columnConfig={this.props.columnConfig}
                />);

                if (found && found.associated.length > 0)
                    found.associated.forEach(assoc_row => {
                        let row_id = "P" + assoc_row._id
                        let assoc_fields = this.getTableFlaggerFields(assoc_row);

                        if (assoc_row._id !== file._id)
                            rows.push(<Row
                                parentRow={false}
                                childRow={true}
                                viewPortfolio={this.props.viewPortfolio}
                                onRowClicked={this.props.checkChange}
                                rightAlign={[]}
                                is_checked={this.state.selectedIds.has(file._id)}
                                checked={this.props.checked}
                                i={i}
                                checkChange={(id) => this.toggleRowSelection(id)}
                                refresh={this.props.refresh}
                                id={row_id}
                                fileid={assoc_row._id}
                                tr_css={grid_css}
                                filename={assoc_fields[0]}
                                filetypedesc={assoc_fields[1]}
                                version={assoc_fields[2]}
                                user={assoc_fields[3]}
                                file={assoc_row}
                                dated={assoc_fields[4]}
                                fileTable={true}
                                columnConfig={this.props.columnConfig}
                            />);
                    });
            }
            else if (this.props.add) {
                if (isDummyRow) {
                    rows.push(
                        <Flag flag="HideDummyRows" entity={{ id: 1 }} case="off">
                            <Row
                                expandLogs={this.props.expandLogs}
                                parentRow={isParentRow}
                                childRow={isChildRow}
                                viewPortfolio={this.props.viewPortfolio}
                                onRowClicked={this.toggleViewModal}
                                rightAlign={[5]}
                                is_checked={this.state.selectedIds.has(file._id)}
                                checked={this.props.checked}
                                i={i}
                                checkChange={(id) => this.toggleRowSelection(id)}
                                refresh={this.props.refresh}
                                id={id}
                                fileid={file._id}
                                tr_css={grid_css}
                                filename={fields[0]}
                                filetypedesc={fields[1]}
                                filetype={file.DocumentType}
                                description={fields[5]}
                                version={fields[2]}
                                user={fields[3]}
                                file={file}
                                pages={file.Pages}
                                dated={fields[4]}
                                fileTable={true}
                                columnConfig={this.props.columnConfig}
                            />
                        </Flag>
                    )
                } else {
                    rows.push(<Row
                        expandLogs={this.props.expandLogs}
                        parentRow={isParentRow}
                        childRow={isChildRow}
                        viewPortfolio={this.props.viewPortfolio}
                        onRowClicked={this.toggleViewModal}
                        rightAlign={[5]}
                        is_checked={this.state.selectedIds.has(file._id)}
                        checked={this.props.checked}
                        i={i}
                        checkChange={(id) => this.toggleRowSelection(id)}
                        refresh={this.props.refresh}
                        id={id}
                        fileid={file._id}
                        tr_css={grid_css}
                        filename={fields[0]}
                        filetypedesc={fields[1]}
                        filetype={file.DocumentType}
                        description={fields[5]}
                        version={fields[2]}
                        user={fields[3]}
                        file={file}
                        pages={file.Pages}
                        dated={fields[4]}
                        fileTable={true}
                        columnConfig={this.props.columnConfig}
                    />);
                }
            }
            else {
                rows.push(<Row
                    viewPortfolio={this.props.viewPortfolio}
                    onRowClicked={this.toggleViewModal}
                    rightAlign={[5]}
                    is_checked={this.state.selectedIds.has(file._id)}
                    checked={this.props.checked}
                    i={i}
                    checkChange={(id) => this.toggleRowSelection(id)}
                    refresh={this.props.refresh}
                    id={id}
                    fileid={file._id}
                    tr_css={grid_css}
                    filename={fields[0]}
                    filetypedesc={fields[1]}
                    filetype={file.DocumentType}
                    description={fields[5]}
                    version={fields[2]}
                    user={fields[3]}
                    file={file}
                    pages={file.Pages}
                    dated={fields[4]}
                    fileTable={true}
                    columnConfig={this.props.columnConfig}
                />);
            }


            })
        }

        

        if (this.props.refresh) {
            let goToPageItems = [];
            for (let i = 0; i < numPages; i++) {
                goToPageItems.push(<li class="s-list-li s-list-default-li"><a onClick={() => this.goToPageNumber(i)} title={i} class="s-list-default-btn-default">{i + 1}</a></li>);
            }

            for (const i of pageSizes)
                pageSizeItems.push(<li class="s-list-li s-list-default-li"><a onClick={() => this.adjustPageSize(i)} title={i} class="s-list-default-btn-default">{i}</a></li>);


            pagination = <div>
                <div class="s-array-topbar-right">
                    {/*<label class="s-pager-range">{this.props.files.length > 1 ? this.props.files.length + " Records" : this.props.files.length + " Record"}</label>*/}
                    <label class="s-pager-range">{this.props.files.length > 1 ? localisation['table_header_records'] ? this.props.files.length + ' ' + localisation['table_header_records'].element_lang : this.props.files.length + ' Records' : localisation['table_header_record'] ? this.props.files.length + ' ' + localisation['table_header_record'].element_lang : this.props.files.length + ' Record'}</label>
                    <label class="s-pager-range">|</label>
                    <label class="s-pager-size-label">Page Size:</label>
                    <div class="s-pager-size-value s-inplace s-responsive-field-size-14"><div class="s-inplace-value-edit">
                        <input type="text" autocomplete="off" class="s-inplace-input" onChange={(e) => this.adjustPageSize(e.target.value)} value={this.state.rowsShown} id="5-106-input" />
                        <div onClick={() => this.setState({ pageSizePopoverOpen: !this.state.pageSizePopoverOpen })} title="Open selection list" id="pagesize-dropdown" style={{ cursor: 'pointer' }} class="s-inplace-edit-picker s-fonticon-btn s-btn-expand_m"></div>
                        <Popover placement="buttom" hideArrow={true} toggle={() => this.setState({ pageSizePopoverOpen: false })} isOpen={this.state.pageSizePopoverOpen} target={"pagesize-dropdown"} style={{ overflow: 'auto', maxHeight: '300px' }}>
                            <div class="s-scrollbar-slot s-list-default-scroll-slot">
                                <div class="s-scrollbar-slot s-list-default-scroll-slot" style={{ paddingRight: '0px', minWidth: '50px' }}></div>
                                <div class="s-scrollbar-view s-list-default-ul-row s-list-row">
                                    <ul class="s-list-ul s-list-default-ul s-list-col" style={{ width: '100%', textAlign: 'center', fontWeight: 'bold' }}>
                                        {pageSizeItems}
                                    </ul>
                                </div>
                            </div>
                        </Popover>
                    </div>
                    </div>
                    <div class="s-pager-size">
                        <label class="s-pager-size-label">Go to Page:</label>
                        <div class="s-pager-size-value s-inplace s-responsive-field-size-14"><div class="s-inplace-value-edit">
                            <input type="text" autocomplete="off" class="s-inplace-input" onChange={(e) => this.jumpToPageNumber(e.target.value)} value={this.state.textPageNumber} id="5-106-input" />
                            <div onClick={() => this.setState({ jumpToPopoverOpen: !this.state.jumpToPopoverOpen })} title="Open selection list" id="jump-dropdown" style={{ cursor: 'pointer' }} class="s-inplace-edit-picker s-fonticon-btn s-btn-expand_m"></div>
                            <Popover placement="buttom" hideArrow={true} toggle={() => this.setState({ jumpToPopoverOpen: false })} isOpen={this.state.jumpToPopoverOpen} target={"jump-dropdown"} style={{ overflow: 'auto', maxHeight: '300px' }}>
                                <div class="s-scrollbar-slot s-list-default-scroll-slot">
                                    <div class="s-scrollbar-slot s-list-default-scroll-slot" style={{ paddingRight: '0px', minWidth: '50px' }}></div>
                                    <div class="s-scrollbar-view s-list-default-ul-row s-list-row">
                                        <ul class="s-list-ul s-list-default-ul s-list-col" style={{ width: '100%', textAlign: 'center', fontWeight: 'bold' }}>
                                            {goToPageItems}
                                        </ul>
                                    </div>
                                </div>
                            </Popover>
                        </div>
                        </div>
                    </div>
                    <label class="s-pager-size-label">Page {currentPage + 1} / {numPages}</label>
                    <div class="s-pager">
                        <a onClick={this.goToPrevPage} class="s-pager-link s-fonticon-btn s-btn-previous"></a>
                        <a onClick={this.goToNextPage} class="s-pager-link s-fonticon-btn s-btn-next"></a>
                    </div>
                    <a onClick={this.props.refresh} class="s-mn-list-btn s-pager-link s-fonticon-btn s-mn-link s-btn-refresh"></a>
                    <button
                        className="btn btn-sm btn-outline-secondary"
                        style={{ marginLeft: '10px' }}
                        onClick={this.toggleFilters}
                        title={this.state.showFilters ? 'Hide search filters' : 'Show search filters'}
                    >
                        <i className="fa fa-filter" aria-hidden="true"></i>
                        <span style={{ marginLeft: '5px' }}>
                        {this.state.showFilters ? 'Hide search Filters' : 'Show search Filters'}
                        </span>
                    </button>
                    {filtersActive && (
                        <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={this.clearAllFilters}
                            title="Clear all filter fields"
                            style={{ marginLeft: '10px' }}
                        >
                            <i className="fa fa-times" aria-hidden="true" style={{ marginRight: '5px' }}></i>
                            Clear Filters
                        </button>
                    )}
                </div>
                <div class="s-array-topbar-left">
                    {(showSelectVisible && this.props.columnConfig?.checkbox) && (
                        <button
                            className="btn btn-sm btn-outline-secondary"
                            style={{ marginLeft: '1px' }}
                            onClick={() => this.toggleSelectAllVisible(visibleIds)}
                            title={allVisibleSelected ? 'Deselect all visible' : 'Select all visible'}
                            >
                            {allVisibleSelected ? 'Deselect visible' : 'Select visible'}
                        </button>
                    )}
                    {(this.props.columnConfig?.checkbox && selectedCount > 0) && (
                        <span
                        className="s-selected-count"
                        aria-live="polite"
                        style={{ marginLeft: 10, fontWeight: 600 }}
                        >
                        Selected: {selectedCount}
                        </span>
                    )}
                    {(this.props.columnConfig?.checkbox && this.state.selectedIds.size > 0) && (
                        <>
                        <button
                            className="btn btn-sm btn-primary"
                            style={{ marginLeft: '10px' }}
                            onClick={this.downloadSelected}
                            title="Download selected documents"
                        >
                            Download Selected ({this.state.selectedIds.size})
                        </button>

                        <button
                            type="button"
                            className="btn btn-link btn-sm"
                            style={{ marginLeft: '6px', paddingLeft: 0, textDecoration: 'underline' }}
                            onClick={this.clearAllSelections}
                            title="Clear all selected items"
                            aria-label="Clear all selected items"
                        >
                            Clear all
                        </button>
                        </>
                    )}
                </div>
            </div>

        }
        else
            pagination = <div class="s-array-topbar-right">
                {/*<label class="s-pager-range">{this.props.files.length > 1 ? this.props.files.length + " Records" : this.props.files.length + " Record"}</label>*/}
                <label class="s-pager-range">{this.props.logs.length > 1 ? localisation['table_header_records'] ? this.props.logs.length + ' ' + localisation['table_header_records'].element_lang : this.props.logs.length + ' Records' : localisation['table_header_record'] ? this.props.logs.length + ' ' + localisation['table_header_record'].element_lang : this.props.logs.length + ' Record'}</label>
                <label class="s-pager-range">|</label>
                <label class="s-pager-size-label">Page {currentPage + 1} / {numPages}</label>
                <div class="s-pager">
                    <a onClick={this.goToPrevPage} class="s-pager-link s-fonticon-btn s-btn-previous"></a>
                    <a onClick={this.goToNextPage} class="s-pager-link s-fonticon-btn s-btn-next"></a>
                </div>
            </div>
        //}

        let addDocumentModalPopup = <div />
        let viewDocumentModalPopup = <div />

        if (this.state.viewmodal)
            viewDocumentModalPopup = <ViewDocumentModal
                type={this.state.selectedFile.DocumentType}
                name={this.state.selectedFile.DocumentRef}
                file={this.state.selectedFile}
                document={this.state.selectedFile._id}
                modal={this.state.viewmodal}
                toggle={this.toggleViewModal} />
        else
            viewDocumentModalPopup = <div />


        if (this.state.addmodal)
            addDocumentModalPopup = <AddDocumentFormModal
                refresh={this.props.refresh}
                parentType={this.props.DocumentType}
                parentRef={this.props.DocumentRef}
                fileName={this.state.selectedFileName}
                fileData={this.state.selectedDocument}
                addmodal={this.state.addmodal}
                toggleAddModal={this.toggleAddModal} />


        let progress = <div />

        if (this.props.loading)
            progress = <Progress color="info" animated value={100} />

        return (
            <>
                {add_button}
                {pagination}
                <div class="s-slot-row" style={{ height: '600px' }}>
                    <div className='table-responsive-wrap'>
                        <Table responsive={true} hover={true} className="s-grid-table-head">
                            <thead>
                                <tr>
                                    {this.props.columnConfig?.expand && (
                                    <th className="s-grid-title-cell s-grid-title-cell-small">
                                        <div className="s-grid-title-empty"></div>
                                    </th>
                                    )}
                                    {this.props.columnConfig?.checkbox && (
                                    <th className="s-grid-title-cell s-grid-title-cell-small">
                                        <div className="s-grid-title-empty"></div>
                                    </th>
                                    )}
                                    {(this.props.columnConfig?.actions ?? true) && (
                                    <th className="s-grid-title-cell s-grid-title-cell-small">
                                        <div className="s-grid-title-empty"></div>
                                    </th>
                                    )}
                                    {this.renderSortableFilterableHeader(
                                        'DocumentRef',
                                        'Document Ref',
                                        'TableHeaderFields', // flag
                                        { id: 1 },           // entity
                                        'on',                // case
                                        true                 // show filter input
                                    )}
                                    {this.renderSortableFilterableHeader(
                                        'SecondRef',
                                        'Second Ref',
                                        'TableHeaderFields', // flag
                                        { id: 2 },           // entity
                                        'on',                // case
                                        false                // show filter input
                                    )}
                                    {this.renderSortableFilterableHeader(
                                        'DocumentNumber',
                                        'Document Number',
                                        'TableHeaderFields', // flag
                                        { id: 3 },           // entity
                                        'on',                // case
                                        false                // show filter input
                                    )}
                                    {this.renderSortableFilterableHeader(
                                        'DocumentType',
                                        'Document Type',
                                        'TableHeaderFields', // flag
                                        { id: 4 },           // entity
                                        'on',                // case
                                        true                // show filter input
                                    )}
                                    {this.renderSortableFilterableHeader(
                                        'Description',
                                        'Description',
                                        'TableHeaderFields', // flag
                                        { id: 11 },           // entity
                                        'on',                // case
                                        true                // show filter input
                                    )}
                                    {this.renderSortableFilterableHeader(
                                        'Folder',
                                        'Folder',
                                        'TableHeaderFields', // flag
                                        { id: 5 },           // entity
                                        'on',                // case
                                        false                // show filter input
                                    )}
                                    {this.renderSortableFilterableHeader(
                                        'Version',
                                        'Version',
                                        'TableHeaderFields', // flag
                                        { id: 6 },           // entity
                                        'on',                // case
                                        true                // show filter input
                                    )}
                                    {this.renderSortableFilterableHeader(
                                        'Value',
                                        'Value',
                                        'TableHeaderFields', // flag
                                        { id: 7 },           // entity
                                        'on',                // case
                                        false                // show filter input
                                    )}
                                    {this.renderSortableFilterableHeader(
                                        'UserName',
                                        'UserName',
                                        'TableHeaderFields', // flag
                                        { id: 8 },           // entity
                                        'on',                // case
                                        true                // show filter input
                                    )}
                                    {this.renderSortableFilterableHeader(
                                        'Pages',
                                        'Pages',
                                        'TableHeaderFields', // flag
                                        { id: 9 },           // entity
                                        'on',                // case
                                        false                // show filter input
                                    )}
                                    {this.renderSortableFilterableHeader(
                                        'DateTimeCreated',
                                        'DateTimeCreated',
                                        'TableHeaderFields', // flag
                                        { id: 10 },           // entity
                                        'on',                // case
                                        true                // show filter input
                                    )}
                                </tr>
                            </thead>
                        </Table>
                    </div>
                    <div class="s-grid-slot-body">
                        <DropZoneTable dropzone={this.props.dropzone} refresh={this.props.refresh} rows={rows} DocumentType={this.props.DocumentType} DocumentRef={this.props.DocumentRef} />
                        {progress}
                    </div>
                    {addDocumentModalPopup}
                    {viewDocumentModalPopup}
                    <input id="addfileId" type="file" style={style} accept=".pdf"></input>
                </div>
            </>
        );
    }
}

export default connect(state => state)(FileTable);